import { createStore, createEvent } from 'effector';

/**
 * Store saves the state of whether main application content is overlayed by some modal, floating popup, etc.
 * Some components will listen to this store and reacrt accordingly, for example by hiding components that better be hidden when a modal is active.
 */
export const $contentOverlayed = createStore({
  isOverlayed: false,
});

export const setContentOverlayedEvent = createEvent<boolean>();

$contentOverlayed.on(setContentOverlayedEvent, (state, isOverlayed) => ({
  ...state,
  isOverlayed,
}));
